import styled from "styled-components";

const UpdateStyles = styled.div`
  svg {
    font-size: 20px;
  }
`;
export default UpdateStyles;



// WEBPACK FOOTER //
// ./src/Pages/Update/updateStyled.js